const SvgProtocol = (props) => (
  <svg height="1em" viewBox="0 0 16 15" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-1-2h18v18H-1z" />
      <path
        d="M3.207.353l-2.5 2.5 2.5 2.5M1.259 2.853h14.5M12.81 14.178l2.5-2.5-2.5-2.5M14.759 11.678H.259"
        stroke="currentColor"
      />
    </g>
  </svg>
)

export default SvgProtocol
